import { InmateActivityType } from '@reliance/types/enums/InmateActivityType';

const enumValues = Object.values(InmateActivityType).map((activityType) => ({
  value: activityType,
  label: activityType,
}));

enumValues.sort((first, second) => first.label.localeCompare(second.label));

/** Select options for inmate activity `type` column filters (wallet and A/V tables). */
export const INMATE_ACTIVITY_TYPE_FILTER_OPTIONS: Array<{ value: string; label: string }> = [
  { value: '', label: '(any)' },
  ...enumValues,
];
